module.exports = __webpack_public_path__ + "static/media/OpenInAppStyle.ba31274c.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/mailSentComp/OpenInAppStyle.scss
// module id = 52
// module chunks = 1